import React from 'react';
import { Handshake, MapPin, Settings, RefreshCcw } from 'lucide-react';

const Services = () => {
  const serviceData = [
    {
      title: "Consultancy",
      description: "Get comprehensive advice from Inframantra property experts.",
      icon: <Handshake size={32} />,
      highlight: true
    },
    // {
    //   title: "Guided Site Visits",
    //   description: "Explore your dream home with experts at the time of your choice.",
    //   icon: <MapPin size={32} />,
    //   highlight: false
    // },
    {
      title: "Post-Sales Support",
      description: "From home loans to key-handovers, we take care of everything.",
      icon: <Settings size={32} />,
      highlight: true
    },
    {
      title: "Portfolio Management",
      description: "Achieve your long term financial goals with advisory support.",
      icon: <RefreshCcw size={32} />,
      highlight: false
    }
  ];

  return (
    <section className="services-section">
      <div className="services-header">
        <h1>Your Vision, Our Expertise.</h1>
        <p>Simplifying the complex world of Indian real estate.</p>
      </div>

      <div className="services-grid">
        {serviceData.map((service, index) => (
          <div key={index} className={`service-card ${service.highlight ? 'gold-card' : 'white-card'}`}>
            <div className="icon-wrapper">
              <div className="icon-circle">{service.icon}</div>
            </div>
            <h3>{service.title}</h3>
            <p>{service.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Services;